import './FooterPortal.css';

import { Component, ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  rootElement?: Element;
  rootSelector?: string;
  children: ReactNode;
}

export class FooterPortal extends Component<Props> {
  private el: Element;
  private root: Element;

  constructor(props: Props) {
    super(props);

    this.el = document.createElement('div');
    const root =
      props.rootElement ??
      document.querySelector(props.rootSelector ?? '#app-footer-fixed');

    if (!root) throw new Error('FooterPortal could not find a root');

    this.root = root;
  }

  override componentDidMount(): void {
    this.root.appendChild(this.el);
  }

  override componentWillUnmount(): void {
    this.root.removeChild(this.el);
  }

  override componentDidUpdate(prevProps: Readonly<Props>): void {
    let element: Element | undefined = undefined;
    if (
      prevProps.rootSelector !== this.props.rootSelector &&
      this.props.rootSelector
    ) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      element = document.querySelector(this.props.rootSelector)!;
    } else if (
      prevProps.rootElement !== this.props.rootElement &&
      this.props.rootElement
    ) {
      element = this.props.rootElement;
    }

    if (element) {
      this.root = element;
      this.root.appendChild(this.el);
    }
  }

  override render(): ReactNode {
    if (!this.props.children) return null;

    // @ts-ignore for some reason tsc is using the wrong React version here, pulling instead from testing-library
    return createPortal(this.props.children, this.el);
  }
}
